import styled, { css } from 'styled-components';

import StyledGlobal from '@tmh-website/styles/global';

import { type HeaderThemeColor, headerThemes } from '../Header.theme';

export const Container = styled.div<{ $headerThemeColor: HeaderThemeColor; $inMenu: boolean }>`
  display: flex;
  transition: background-color 0.5s ease;
  ${props =>
    !props.$inMenu &&
    css`
      align-items: flex-end;
      height: ${props.theme.headerAudienceTabsHeight};
      background-color: ${props.theme.color[headerThemes[props.$headerThemeColor].audienceTabsBackground]};
    `};
`;

export const AdjustedWrapperLarge = styled(StyledGlobal.WrapperLarge)`
  display: flex;
  gap: 4px;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
`;

export const AudiencesContainer = styled.div<{ $inMenu: boolean }>`
  display: flex;
  gap: 30px;
  align-items: center;
  margin: 10px 0;
  ${props =>
    !props.$inMenu &&
    css`
      gap: 4px;
      align-items: flex-end;
      margin: 0;
    `}
`;
